<template>
  <div>
    <div v-if="cover" class="Popupclass">
      <div class="close">
        <div style="padding: 3vw;text-align: left;" >
          <img
            style="width: 4vw; height: 4vw"
            src="./img/close.png"
            alt=""
            @click="closeclick"
          />
        </div>
        <div style="margin-bottom: 25px">
          <div
            style="
              font-size: 17px;
              text-align: center;
              color: #000000;
              font-weight: 500;
            ">
            {{title}}
          </div>
        </div>
        <div style="padding: 0px 20px;border-top: 1px solid #dcdfe6;width: 90%;margin: 0 auto;">
          <div style="font-family: PingFangSC, PingFang SC;font-weight: 400;font-size: 15px;color: #000000;line-height: 21px;text-align: justify;font-style: normal;margin-top:20px">
           {{name}}
          </div>
        </div>
      </div>
    </div>
    <div id="cover" v-if="cover"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cover: false,
    };
  },
  watch: {
    bulletFrameIf: function (newVal, oldVal) {
      this.cover = newVal;
    },
  },
  props: [
    "title",
    "name",
    "bulletFrameIf"
  ],
  mounted() {
    // this.cover = this.bulletFrameIf
    console.log(this.bulletFrameIf)
    console.log(this.title)
    console.log(this.name)
  },
  methods: {
    closeclick() {
      this.cover = false;
      this.$emit('close-method', false);
    },
  },
};
</script>
<style scoped>
#cover {
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  filter: alpha(opacity=100); /*设置透明度为100%*/
  opacity: 1; /*非IE浏览器下设置透明度为100%*/
  display: block;
  z-index: 999;
}
img {
  width: 100%;
  height: 100%;
}
.Popupclass {
  position: fixed;
  bottom: 0vw;
  z-index: 9999;
}
.Popupclass {
  width: 100%;
  z-index: 9999;
  background-color: #ffffff;
  margin: 0 auto;
  margin-top: 15vw;
  box-sizing: border-box;
}
.close {
  color: #666666;
  text-align: right;
  margin-bottom: 100px;
}
.el-input {
  width: 115% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bulletFrame.vue